module.exports = __webpack_public_path__ + "media/customizations/cotavera/logo-426114ac2d0479d71e53d513b3b89823.png";